// Native list-card init: what Boost's customization.js afterRender() did for its cards
// (_assets/boost-turbo/assets/customization.js), run once over server-rendered cards.
(function () {
	function formatDate(date) {
		const d = String(date.getDate()).padStart(2, '0');
		const m = String(date.getMonth() + 1).padStart(2, '0');
		const y = date.getFullYear();
		return `${d}.${m}.${y}`;
	}

	function processEuPriceDirective(productItem) {
		const el = productItem.querySelector('.did-eu-price-directive');
		if (!el || el.dataset.processed) return;
		el.dataset.processed = '1';

		const sku = el.dataset.sku;
		const currentPrice = parseFloat(el.dataset.currentPrice);

		let history;
		try { history = JSON.parse(el.dataset.priceHistory); } catch(e) { return; }

		const items = history[sku];
		if (!items || items.length < 2) return;

		const lastItem = items[items.length - 1];
		const dateLastChanged = new Date(new Date(lastItem.createdAt.date).setHours(0,0,0,0));
		const thirtyDaysAgo = new Date(dateLastChanged.getTime() - 30 * 864e5);

		let lowestSeenPrice = currentPrice;
		let wasPriceText = '';
		let euText = '';
		let displayNothing = false;

		for (let i = 0; i < items.length - 1; i++) {
			const changedPrice = parseFloat(items[i].price);
			const startDate = new Date(items[i].createdAt.date);
			const endDate = new Date(items[i + 1].createdAt.date);

			if (endDate < thirtyDaysAgo) continue;

			if (changedPrice <= currentPrice) {
				displayNothing = true;
				continue;
			}

			if (lowestSeenPrice === currentPrice) lowestSeenPrice = changedPrice;

			if (changedPrice <= lowestSeenPrice) {
				lowestSeenPrice = changedPrice;
				const diff = (lowestSeenPrice - currentPrice).toFixed(2);
				wasPriceText = `<span class="saved-price">Save <span class="money">€${diff}</span></span>`;
				euText = `<span class="eu-pricing-directive">Was: €${lowestSeenPrice.toFixed(2)}<br>from ${formatDate(startDate)} to ${formatDate(endDate)}</span>`;
			}
		}

		if (displayNothing || !wasPriceText) return;

		const priceWrapper = productItem.querySelector('.boost-sd__product-price');
		if (priceWrapper) {
			priceWrapper.insertAdjacentHTML('beforeend', wasPriceText + euText);
		}
	}

	function init() {
		document.querySelectorAll('.boost-sd__product-item').forEach(processEuPriceDirective);
		// humm.js fills .product-thumbnail__humm-price on this event
		if (window.jQuery) {
			window.jQuery('body').trigger('bpfs-theme-built');
		}
		if (typeof lipscore !== 'undefined' && lipscore.initWidgets) {
			lipscore.initWidgets();
		}
	}

	// Same capture-phase guard as Boost: links inside the card must not trigger card-level handlers
	document.addEventListener('click', (e) => {
		if (e.target.closest('.wee-price a, .product-thumbnail__details-link, .product-fiche')) {
			e.stopPropagation();
			e.stopImmediatePropagation();
		}
	}, true);

	// BSS Product Labels drops its label layer (.bss_pl_img) straight into the card, so badges
	// anchor to the card corners (over the button). Move it into the image block as it appears.
	function adoptBssLayers(root) {
		root.querySelectorAll('.boost-sd__product-item-list-view-layout > .bss_pl_img').forEach((layer) => {
			const image = layer.parentElement.querySelector('.boost-sd__product-item-list-view-layout-image');
			if (image) image.appendChild(layer);
		});
	}

	function watchBss() {
		const list = document.querySelector('.sf9-list-collection__items');
		if (!list) return;
		adoptBssLayers(list);
		new MutationObserver(() => adoptBssLayers(list)).observe(list, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', watchBss);
	} else {
		watchBss();
	}

	// humm.js binds its listener in a jQuery(document).ready callback, so run after all ready
	// callbacks (setTimeout). Don't wait for window load: a slow third-party resource can hold
	// it off indefinitely. Run again on load for late widgets; init is safe to repeat
	// (humm.js empties its box first, the EU notice is guarded by data-processed).
	function start() {
		if (window.jQuery) {
			window.jQuery(() => setTimeout(init, 0));
		} else {
			init();
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start);
	} else {
		start();
	}
	window.addEventListener('load', init);
})();
